import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import waitingImage from '../Img/waiting.png';
import SofBenLogo from '../Img/SofBenLogo.jpg'; 
import { signOut } from 'firebase/auth';
import { auth } from '../Firebase';
import { useNavigate } from 'react-router-dom';

function WaitingRoom() {

  const navigate = useNavigate(); 

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/'); 
    } catch (error) {
      console.error('Logout error:', error);
    }
  };



  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundColor: '#fff',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        px: 2,
        textAlign: 'center',
      }}
    >
      {/* Logo */}
      <Box
        component="img"
        src={SofBenLogo}
        alt="SofBen Logo"
        sx={{ width: 250, mb: 4 }}
      />

      {/* Waiting Image */}
      <Box
        component="img"
        src={waitingImage}
        alt="Waiting Illustration"
        sx={{ width: 200, height: 'auto', mb: 4 }}
      />

      {/* Title */}
      <Typography variant="h5" fontWeight="bold" sx={{ color: '#040303', mb: 1 }}>
        En attente de validation
      </Typography>

      {/* Subtitle */}
      <Typography
        variant="body2"
        sx={{ color: '#999', maxWidth: 320 }}
      >
        Merci pour votre inscription. Votre compte est en attente d'approbation par l'administration. Nous vous informerons dès qu'il sera activé.
      </Typography>

      <Button
        variant="outlined"
        onClick={handleLogout}
        sx={{
          mt: 4,
          color: '#c93d3d',
          borderColor: '#c93d3d',
          fontWeight: 'bold',
          borderRadius: 2,
          px: 4
        }}
      >
        Se déconnecter
      </Button>

    </Box>
  );
}

export default WaitingRoom;
